
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number): string {
  // Handle potential NaN or invalid values
  if (isNaN(value) || value === null || value === undefined) {
    return 'R$ 0,00';
  }
  
  // Ensure value has at most 2 decimal places
  const fixedValue = Number(value.toFixed(2));
  
  return fixedValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function formatDate(date: Date | string): string {
  if (!date) return '';
  
  const parsedDate = typeof date === 'string' ? new Date(date) : date;
  
  // Ajustando para horário de Brasília (UTC-3)
  return parsedDate.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Sao_Paulo'
  });
}

export function getDateInBrasiliaTimezone(date = new Date()): Date {
  // Brasília timezone is UTC-3
  const brasiliaDate = new Date(date);
  // No need to adjust the date manually as we're using the browser's timezone handling
  // Just ensuring we're returning a date object
  return brasiliaDate;
}

export function formatTableName(table: { number: number; name?: string }): string {
  // If the table has a custom name, use it, otherwise format as "Mesa X"
  return table.name || `Mesa ${table.number}`;
}

export function getCompanyLogo(): string {
  // Try to get the logo from localStorage first
  const storedLogo = localStorage.getItem('empresa_logo');
  // If not found, use the default logo
  return storedLogo || '/images/logo.png';
}
